/** Fallback-Titel für CentralizedExportPrintButton (LanguageContext). */
export const exportPrintButtonFr = {
  defaultReportTitle: 'Rapport'
};

export const exportPrintButtonAr = {
  defaultReportTitle: 'تقرير'
};
